<div class="periods-container">
    <form [formGroup]="form">
        <div formArrayName="periods" class="periods-array">
            @if (periodsArray.controls.length) {
                @for(period of periodsArray.controls; let i = $index; track $index;) {
                <div [formGroupName]="i">
                    <div class="period">
                        <mat-form-field appearance="outline" class="time-input">
                            <input matInput type="time" id="open-{{ i }}" formControlName="open">
                        </mat-form-field>
                        <p>-</p>
                        <mat-form-field appearance="outline" class="time-input">
                            <input matInput type="time" id="close-{{ i }}" formControlName="close">
                        </mat-form-field>
                    </div>
                </div>
                <button mat-mini-fab color="error" (click)="removePeriod(i)"
                    [disabled]="isHolidayDate(day) && day.syncWithDefaultPeriods">
                    <mat-icon>remove</mat-icon>
                </button>
            }
            @if (form.valid) {
                <button mat-mini-fab (click)="addPeriod()" [disabled]="isHolidayDate(day) && day.syncWithDefaultPeriods">
                    <mat-icon>add</mat-icon>
                </button>
            }
            @else if (periodsArray.errors?.['incomplete']) {}
            @else if (periodsArray.errors?.['overlapping']) {
                <mat-icon class="error">warning</mat-icon>
                <p class="admin-text error">Öffnungszeiten überschneiden sich</p>
            }
            @else if (periodsArray.errors?.['invalidOrder']) {
                <mat-icon class="error">warning</mat-icon>
                <p class="admin-text error">Schließzeit liegt vor der Öffnungszeit</p>
            }
            }
            @else {
                <p class="admin-text admin-primary">Geschlossen</p>
                <button mat-mini-fab (click)="addPeriod()" [disabled]="isHolidayDate(day) && day.syncWithDefaultPeriods">
                    <mat-icon>add</mat-icon>
                </button>
            }
        </div>
    </form>
</div>